import React, {useEffect} from "react";
import './AlertRulesList.scss'
import {useDispatch, useSelector} from "react-redux";
import {ReactComponent as EditIcon} from "../../assets/icons/editPenIcon.svg";

const selector = state => {
    const { language, alertRules, modalState } = state;
    return {
        t: language.translator,
        pending: alertRules.pending,
        alertRules: alertRules.alertRules,
        selected: alertRules.selected,
        alertMessages: alertRules.alertMessages,
        modalState: modalState
    }
};

const AlertRulesList = props => {
    const {items, selectItemMethod, selected, editMethod} = props;
    const {t} = useSelector(selector)
    const dispatch = useDispatch();


    const handleItemClick = (item) => {
        dispatch(selectItemMethod(item))
    }

    return (
        <div className="AlertRulesListContainer">
            <table className={'AlertRulesListTable'}>
                <thead>
                <tr>
                    <th rowSpan={2}>{t.gettext('Alert name')}</th>
                    <th rowSpan={2}>{t.gettext('Unit')}</th>
                    <th colSpan="2">{t.gettext('Lower threshold')}</th>
                    <th colSpan="2">{t.gettext('Upper threshold')}</th>
                    <th rowSpan={2}>{t.gettext('Edit')}</th>
                </tr>
                <tr>
                    <th>{t.gettext('Critical Alert')}</th>
                    <th>{t.gettext('Standard Alert')}</th>
                    <th>{t.gettext('Standard Alert')}</th>
                    <th>{t.gettext('Critical Alert')}</th>
                </tr>
                </thead>
                <tbody>
                {items && items.length > 0 && items.map(x => {
                    return (
                        <tr onClick={() => handleItemClick(x)}>
                            <td>{x.ruleName}</td>
                            <td>{x.measurementTypeUnit}</td>
                            <td className={'criticalAlert'}>{
                                (x?.thresholds?.find(y => y.warningType === 'ALARM_LOW')?.value !== undefined)
                                    ? String(x.thresholds.find(y => y.warningType === 'ALARM_LOW')?.value || 0)
                                    : '-'
                            }</td>

                            <td className={'standardAlert'}>{
                                (x?.thresholds?.find(y => y.warningType === 'WARNING_LOW')?.value !== undefined)
                                    ? String(x.thresholds.find(y => y.warningType === 'WARNING_LOW')?.value || 0)
                                    : '-'
                            }</td>

                            <td className={'standardAlert'}>{
                                (x?.thresholds?.find(y => y.warningType === 'WARNING_HIGH')?.value !== undefined)
                                    ? String(x.thresholds.find(y => y.warningType === 'WARNING_HIGH')?.value || 0)
                                    : '-'
                            }</td>

                            <td className={'criticalAlert'}>{
                                (x?.thresholds?.find(y => y.warningType === 'ALARM_HIGH')?.value !== undefined)
                                    ? String(x.thresholds.find(y => y.warningType === 'ALARM_HIGH')?.value || 0)
                                    : '-'
                            }</td>
                            <td>
                                <div onClick={() => editMethod(x)} className="tableIconContainer">
                                    <EditIcon/>
                                </div>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        </div>
    )
}

export default AlertRulesList
